module.exports = __webpack_public_path__ + "static/img/home_Phone_Img.64e4d0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Desktop/Home_Landing/home_Phone_Img.png
// module id = 4JT/
// module chunks = 0